import { List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "@/components/userAdministration/csvImportResult.module.css";

interface SkippedCsvEntry {
  email?: string;
  name?: string;
  fields?: Record<string, string[] | string>;
}

export interface CsvImportResultData {
  "created entries"?: unknown[];
  "updated entries"?: unknown[];
  "skipped entries"?: SkippedCsvEntry[];
}

interface Props {
  result?: CsvImportResultData | null;
  createdLabel: string;
  updatedLabel: string;
}

const formatSkippedEntryErrors = (entry: SkippedCsvEntry) =>
  Object.entries(entry.fields ?? {})
    .map(([field, errors]) =>
      Array.isArray(errors)
        ? errors.map((error) => `${field}: ${error}`).join(", ")
        : `${field}: ${errors}`
    )
    .join("; ");

export default function CsvImportResult({
  result,
  createdLabel,
  updatedLabel,
}: Props) {
  const { t } = useTranslation();
  const skippedEntries = result?.["skipped entries"] ?? [];

  return (
    <div className={styles.container}>
      <section className={styles.countRow}>
        <p className={styles.label}>{createdLabel}:</p>
        <span>{result?.["created entries"]?.length ?? 0}</span>
      </section>
      <section className={styles.countRow}>
        <p className={styles.label}>{updatedLabel}:</p>
        <span>{result?.["updated entries"]?.length ?? 0}</span>
      </section>
      <section className={styles.skippedSection}>
        <p className={styles.skippedLabel}>
          {t("incorrect_entries")}: {skippedEntries.length}
        </p>
        {skippedEntries.length > 0 && (
          <List>
            {skippedEntries.map((entry, index) => (
              <ListItem
                key={`${entry.email ?? entry.name ?? "entry"}-${index}`}
                className={styles.skippedListItem}
              >
                <ListItemText
                  primary={entry.email ?? entry.name ?? t("unknown_entry")}
                  secondary={formatSkippedEntryErrors(entry)}
                  secondaryTypographyProps={{ color: "error" }}
                />
              </ListItem>
            ))}
          </List>
        )}
      </section>
    </div>
  );
}
